import React, { useState, useEffect } from 'react'
import BoardItemComponent from './BoardItemComponent.jsx'
import AddStreamer from './forms/AddStreamer.jsx'
import { Streamer } from '../models/streamer.class'
import ListStreamers from './ListStreamers.jsx';
import Header from './pure/Header.jsx';
import GameOver from './gameInfo/GameOver.jsx';
import CountdownCompoent from './gameInfo/Countdown.jsx';
import allStreamers from "../streamerInfo.json";
import { updateLocalStorage, localStoragedefault, getTodayGame } from '../utils/LocalStorage.jsx';
import { getDailyStreamer } from '../utils/GetDailyStreamer.jsx';
import { getShareResult } from '../utils/ShareResult.jsx';

function ageCalculate(date) {
    var today = new Date();
    var birthday = new Date(date);
    var age = today.getFullYear() - birthday.getFullYear();
    var m = today.getMonth() - birthday.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
        age--;
    }

    return age;
}

function createStreamer(streamer) {
    const age = ageCalculate(streamer.birthday)
    return new Streamer(streamer.id, streamer.name, age, streamer.followers, streamer.gender, streamer.city, streamer.platform)
}

function BoardComponent() {
    const tryNumbers = 5;
    const [streamerGuess, setStreamerGuess] = useState()
    const [valueInput, setValueInput] = useState('')
    const [tryStreamers, setTryStreamers] = useState([])
    const [gameOver, setGameOver] = useState(false)
    const [isWon, setIsWon] = useState(false)
    const [showGameOver, setShowGameOver] = useState(false)

    const handleCloseGameOver = () => setShowGameOver(false);

    useEffect(() => {
        const statsLocal = JSON.parse(localStorage.getItem('stats'));
        const streamer = getDailyStreamer()
        const todayGame = getTodayGame(streamer.name)

        if (!statsLocal) {
            localStoragedefault()
        }

        setStreamerGuess(createStreamer(streamer))

        if (todayGame) {
            setTryStreamers(todayGame.tryIds.map((id) => createStreamer(allStreamers[id])))
            setIsWon(todayGame.isWon)
            setGameOver(true)
        }
    }, []);

    function boardAddStreamer(tryStreamer) {
        const tryStreamersTemp = [...tryStreamers, createStreamer(allStreamers[tryStreamer.id])]
        const isWonTry = streamerGuess.id === tryStreamer.id

        setTryStreamers(tryStreamersTemp)
        setValueInput('')

        if (isWonTry || tryStreamersTemp.length === tryNumbers) {
            updateLocalStorage(isWonTry, streamerGuess, tryStreamersTemp)
            setIsWon(isWonTry)
            setGameOver(true)
            setShowGameOver(true)
        }
    }

    function changeInput(value) {
        setValueInput(value)
    }

    return (
        <div className='board'>
            <Header />
            <div className='search-container'>
                <AddStreamer uploadInput={changeInput} valueInput={valueInput} disabled={gameOver} />
                {valueInput ?
                    <ListStreamers selectStreaamer={boardAddStreamer} value={valueInput} tryStreamers={tryStreamers} /> : null
                }
            </div>
            {gameOver && streamerGuess ?
                <div className={isWon ? 'game-result game-result-won' : 'game-result game-result-lost'}>
                    <p className='game-result-title'>{isWon ? '¡Lo has adivinado!' : 'Esta vez no ha podido ser'}</p>
                    <p className='game-result-name'>{streamerGuess.name}</p>
                    <p className='game-result-tries'>
                        {isWon ? `En ${tryStreamers.length} de ${tryNumbers} intentos` : `Has usado los ${tryNumbers} intentos`}
                    </p>
                    <div className='game-result-countdown'>
                        <p className='text-share'>Siguiente streamer en</p>
                        <CountdownCompoent />
                    </div>
                </div>
                : null
            }
            <BoardItemComponent streamers={tryStreamers} streamerGuess={streamerGuess} tryNumbers={tryNumbers} />
            {
                showGameOver ?
                    <GameOver
                        show={showGameOver}
                        handleClose={handleCloseGameOver}
                        shareResult={getShareResult(isWon, tryStreamers, streamerGuess, tryNumbers)}
                    />
                    : null}
        </div>
    )
}

export default BoardComponent
